module.exports = __webpack_public_path__ + "img/Dantam Bridal 14b.87144a06.jpg";